import React, { Component } from 'react';
import { BrowserRouter, Route, Link } from 'react-router-dom';
import { getInstructor } from '../common/api';
import { getAllDepartments, getCapitalName } from '../common/utils';

import '../styles/InstructorPage.css';
import '../styles/CoursePage.css';
import '../styles/SearchPage.css';
import SearchBar from '../components/SearchBar';

class InstructorPage extends Component {
    constructor(props) {
        super(props);
        // this._updateDimensions = this._updateDimensions.bind(this);
        this.state = { eidHash: props.match.params.eidHash, instructor: null };
    }

    _loadInstructorDetail() {
        getInstructor(this.state.eidHash).then(_instructor => {
            if (_instructor) this.setState({ instructor: _instructor });
        });
    }

    _updateDimensions() {
    }

    _getCourseGrid() {
        const instructor = this.state.instructor;
        const departments = getAllDepartments();
        const innerGrid = instructor.courses.map(course => {
            return (
                <Link key={ course.id } to={{ pathname: '/course/' + course.id + '/' + this.state.eidHash }} 
                    className="search-result-block instructor-course-grid-link">
                    <div className="instructor-course-grid-block">
                        <u>{ departments[course.department].short_title + " " + course.number }</u>
                        <br />
                        <span>{ course.title }</span>
                    </div>
                </Link>
            );
        });
        return (<div className="instructor-course-grid">{ innerGrid }</div>);
    }

    componentWillMount() {
        this._loadInstructorDetail();
    }

    render() {
        const searchBar = (<div className="search-page-search-bar"><SearchBar /></div>);
        if (!this.state.instructor)
            return (<div>{ searchBar }</div>);

        this._setTitle();
        return (
            <div>
                { searchBar }
                <div className="instructor-page-header">
                    <div id='course-number'>{ this.state.instructor.name }</div>
                </div>
                <div className="instructor-course-grid-container">
                    { this._getCourseGrid() }
                </div>
            </div>
        );
    }

    _setTitle() {
        document.title = getCapitalName(this.state.instructor.name) + ' - Courses';
    }

    componentDidMount() {
        // window.addEventListener("resize", this._updateDimensions);
        if (this.state.instructor) this._setTitle();
    }

    componentWillUnmount() {
        // window.removeEventListener("resize", this._updateDimensions);
    }
}

export default InstructorPage;



// WEBPACK FOOTER //
// ./src/containers/InstructorPage.js